import type { ProjectItem } from '../features/thread/threadSlice';

/**
 * Stato di un progetto di ottimizzazione nell'elenco (SPJ-1366): se ha run completate e se ha
 * una configurazione in corso. Per gli altri progetti non mostra nulla.
 */
export function ProjectStatusBadges({ project }: { project: Pick<ProjectItem, 'canLoad' | 'hasDraft' | 'hasCompletedRun'> }) {
  if (!project.canLoad || (!project.hasDraft && !project.hasCompletedRun)) return null;
  return (
    <div className="mt-1 flex flex-wrap items-center gap-1.5 text-[11px] font-medium">
      {project.hasCompletedRun && (
        <span className="border border-emerald-600/40 bg-emerald-50 px-1.5 py-0.5 text-emerald-800">
          Ottimizzazione completata
        </span>
      )}
      {project.hasDraft && (
        <span className="border border-[#9F6460]/40 bg-[#9F6460]/5 px-1.5 py-0.5 text-[#7d4a47]">
          {project.hasCompletedRun ? 'Bozza in corso' : 'Bozza in corso · nessuna ottimizzazione'}
        </span>
      )}
    </div>
  );
}
